<div class="flex gap-10 mt-5">
	<div class="w-2/3 flex flex-col gap-4">
		<div class="flex flex-col gap-2">
			<div class="flex gap-2 items-center">
				<p class="font-bold text-lg">Total amount</p>
				<app-anchor
					class="text-green underline"
					(onClick)="showBreakdown()"
					[testHook]="testHooks.ViewFeeBreakdownLink"
					>View fee breakdown</app-anchor
				>
			</div>
			<div class="border border-grey-lighter rounded-lg p-2">
				<div class="flex justify-between items-center">
					<h2 class="text-green border-grey border-r pr-10 xl:pr-24">
						{{ amountDueByClient$ | async | centsToDollars }}
					</h2>
					<div
						class="flex flex-col gap-1 w-full items-center relative"
						(mouseover)="togglePill('premium')"
						(mouseout)="togglePill('none')"
					>
						<div>
							<p>Premium</p>
							<p class="font-bold">
								{{ titleInsurance?.premium | centsToDollars }}
							</p>
						</div>
						<div *ngIf="displayPill === 'premium'" class="text-sm pill">
							<app-icon
								[icon]="premiumPillData.icon"
								[class]="premiumPillData.iconClass"
							></app-icon>
							<span>{{ premiumPillData.text }}</span>
						</div>
					</div>
					<div
						class="flex flex-col gap-1 w-full items-center relative"
						(mouseover)="togglePill('counsel')"
						(mouseout)="togglePill('none')"
					>
						<div>
							<p>Counsel credit</p>
							<p class="font-bold">
								{{ titleInsurance?.extendCreditAmount | centsToDollars }}
							</p>
						</div>
						<div *ngIf="displayPill === 'counsel'" class="text-sm pill">
							<app-icon
								[icon]="counselPillData.icon"
								[class]="counselPillData.iconClass"
							></app-icon>
							<span>{{ counselPillData.text }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="flex flex-col gap-2">
			<p class="font-bold text-lg">Policy types</p>
			<div class="w-full grid grid-cols-2 gap-2">
				<app-container *ngFor="let policy of policies$ | async">
					<p class="text-lg font-bold">{{ policyTypeString(policy.type) }}</p>
					<div class="flex items-center gap-2 text-xs mb-4 text-grey">
						<p>{{ policy.number }}</p>
						<p *ngIf="policy.priority">
							MORTGAGE PRIORITY: {{ policy.priority }}
						</p>
					</div>
					<div class="flex gap-2 justify-start">
						<p class="text-grey">Insured amount</p>
						<p>{{ policy.insuredAmount | centsToDollars }}</p>
					</div>
					<div class="flex gap-2 justify-start">
						<p class="text-grey">Name(s) of insured</p>
						<p>{{ policy.name }}</p>
					</div>
				</app-container>
			</div>
		</div>
	</div>
	<div>
		<h4>Documents</h4>
		<div
			class="flex justify-between bg-grey-lightest rounded-xl p-3 my-2 cursor-pointer hover:shadow-md"
			*ngFor="let doc of titleInsurance?.documents"
			(click)="openDoc(doc)"
			[testHook]="testHooks.OpenDocDiv"
		>
			<div class="flex items-center">
				<div
					class="flex items-center justify-center bg-grey-lighter p-2 rounded-md w-12 h-12"
				>
					<app-icon
						class="text-2xl"
						[ngClass]="doc.extension === 'docx' ? 'text-blue' : 'text-red'"
						[icon]="
							doc.loading
								? ICON.LOADING
								: doc.extension === 'docx'
									? ICON.SOLID_WORD
									: ICON.SOLID_PDF
						"
						[spin]="doc.loading"
					></app-icon>
				</div>
				<div class="flex flex-col p-3">
					<span class="font-bold">{{ doc.name }}</span>
					<p class="text-sm">
						Issued on: {{ doc?.issuedOn | date: 'mediumDate' }}
					</p>
				</div>
			</div>
		</div>
	</div>
</div>
